import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state() {
    return {
      userID: "",
      token: "",
      firstname: "",
      lastname: "",
      levelID: "",
      level: "",
      img: "",
      expiresIn: "",
      autoLogout: false,
      edition: 0,
      idtocancel: "",
      frrID: "",
      teamactions: "",
      actionslevel: "",
      actionscomplete: "",
      projectFRR: "",
      closedFRR: "",
      section: "TESTE",
      //FRRdescription: "",
      tebID: "",
      tebName: "",
      trdetail: "",
      //Payload
      payloadID: "",
      observationsPL: "",
      projectPL: "",
      closedPL: "",
      //TR
      trID: "",
      observationsTR: "",
      projectTR: "",
      closedTR: "",
      //VD
      designID: "",
      observationsVD: "",
      projectVD: "",
      closedVD: "",
      //fp
      flightID: "",
      observationsFP: "",
      projectFP: "",
      closedFP: "",
      apogee: "",
      //teste
      id: "",
      project: "",
      closed: "",
      observations: "",
      expiresAt: 0, // new
      showExpiryWarning: false, // new
      countdownSeconds: 0, // new
      forceBypassUnsaved: false,
    };
  },
  mutations,
  getters,
  actions,
};
